import Vue from '../../node_modules/vue';
import imageUrl from '../filter/imageUrl';

Vue.filter('imageUrl', imageUrl);
